import NoImage from '../Assets/Images/Logos/no-image.png'

export const getProductImageUrl = product =>
  product?.URL ||
  product?.Images?.[0]?.URL ||
  product?.DefaultProductPicture ||
  product?.productImage ||
  NoImage
